import { SDK_SCRIPT_ID, SDK_SCRIPT_DATASET, MIN_SITE_ID } from '../config/constants';
import { setSiteId } from '../siteId/siteId';

export default function bootstrap (sdkScript) {
    if (!sdkScript) {
        throw new Error(`Could not find script with required attribute "${SDK_SCRIPT_ID}". SDK not initialized.`);
    }

    const siteId = parseInt(sdkScript.dataset[SDK_SCRIPT_DATASET], 10);

    if (!siteId) {
        throw new Error(`Missing required "${SDK_SCRIPT_ID}" attribute from Collaterate SDK script. SDK not initialized.`);
    }

    if (isNaN(siteId) || siteId < MIN_SITE_ID) {
        throw new Error(`Invalid value for "${SDK_SCRIPT_ID}" attribute on Collaterate SDK script. Value must be a positive integer. SDK not initialized.`);
    }

    setSiteId(siteId);
}
